import React, { useState, Dispatch, SetStateAction, useContext, useEffect } from "react";
import { Button, Label /*, Badge */ } from "reactstrap";

import UserContext from "../contexts/user";
import EventContext from "../contexts/event";
import getEncodedImageUrl from "../helpers/get-encoded-image";
import { useIntl } from "react-intl";

import Footer from "./footer";
import FilterDropdown from "./filter-dropdowns";
import { EslidesEvent, Aggregates, Presentation } from "../types/presentation";
import { FormattedMessage } from "react-intl";
import { useHistory, useParams } from "react-router-dom";
import PresentationItem from "./speaker/presentationItem";
import { PresentationVersion } from "../types/presentation";
import presentationItem from "./speaker/presentationItem";
import axios from "axios";
import { RiEditBoxLine } from "react-icons/ri";
import line from '../containers/Synopsis/Assets/Icons/line.svg'


const SidebarNewVideo: React.FC<{
  event: EslidesEvent;
  aggregates: Aggregates;
  roomId: string | undefined;
  filter: {
    speakers: Array<string>;
    rooms: Array<string>;
    associations: Array<string>;
    dates: Array<string>;
    activeQuizzesOnly: boolean;
  };
  setFilter: Dispatch<SetStateAction<any>>;
  openProfileModal: boolean;
  setOpenProfileModal: (arg0: any) => void;
  presentationName?: string | undefined;
  PresentationDate?: string | undefined;
  PresentationId?: string | undefined;
  filters?: boolean | undefined;
}> = ({
  event,
  aggregates,
  filter,
  setFilter,
  presentationName,
  setOpenProfileModal,
  openProfileModal,
  PresentationDate,
  PresentationId,
  filters,
  roomId
}) => {
    const { event_slug } = useParams<{
      event_slug: string;
    }>();
    let history = useHistory();
    const [box, setBox] = useState("videos");
    const [visioEnabled, setVisioEnabled] = useState(true);
    const userContext = useContext(UserContext);
    const eventContext = useContext(EventContext);
    console.log(userContext.user?.is_speaker);

    console.log("userContext", userContext);
    const intl = useIntl();

    const [showFilters, setShowFilters] = useState(false);

    const [roomName, setRoomName] = useState("");
    const toggleFilters = () => {
      setShowFilters(!showFilters);
    };
    // why this name is speaker if ther is both type of user
    //  this one related to Presentation data from postgres

    // aggergate data coming for speaker related to presentation list
    const { speakers, rooms, associations, dates } = aggregates;
    console.log(speakers);
    const slug = document.location.pathname.split("/")[1] || "invalid";
    let token: any = localStorage.getItem(`token-${slug}`);

    const allSpeakers = speakers
      .sort((a, b) => a.firstName.localeCompare(b.firstName))
      .map((speaker) => ({
        label: `${speaker.title ? `${speaker.title} ` : ""}${speaker.firstName} ${speaker.lastName
          }`,
        value: speaker._id,
      }));
    const allRooms = rooms
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((room) => ({ label: room.name, value: room._id }));
    const allAssosiations = associations
      .filter((f) => f)
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((association) => ({
        label: association.name,
        value: association._id,
      }));
    const allDates = dates
      .sort((a, b) => a.localeCompare(b))
      .map((date) => ({ label: date, value: date }));

    //  console.log(event);
    //  console.log(event.name);
    //  console.log(event.logo);

    console.log("roomData", roomId);

    //get room detail from backend
    async function getRoomData() {
      axios({
        url: `${process.env.REACT_APP_API_ENDPOINT}/api/visio/room/${roomId}`,
        method: 'GET',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then(value => {
        setRoomName(value.data.data.name);
        // check room visio is enabled
        if (value.data.data.visioEnabled !== undefined) {
          setVisioEnabled(value.data.data.visioEnabled);
        } else {
          setVisioEnabled(false);
        }

      }).catch(reason => {
        console.log("getRoomData e", reason);
      }
      )
    }

    useEffect(() => {
      if (roomId !== undefined) {
        // get room data call
        getRoomData();
      }

    }, [roomId]);

    function hasWhiteSpace(s: string) {
      return (/\s/).test(s);
    }
    const formatDate = (dateInput: string | Date) => {
      const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
      return date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    };

    return (
      <div className="sidebar-main sidebar-new-video-main ">
        <div className="logo-container">
          <div className="mb-1">
            <div className="d-flex flex-column align-items-center justify-content-center">
              <div className="image ">
                {/* logoImage IF event logo is available and event loggo is not available*/}
                {event.logo ? (
                  <img
                    className="logo_image_mo"
                    height={70}
                    src={getEncodedImageUrl(event.logo, 110, 100, "contain")}
                    alt="logo"
                  />
                ) : (
                  <div className="logo_image ">
                    <img
                      className="logo_image_mo"
                      src="/images/logo-default.png"
                      alt="logo"
                    />
                  </div>
                )}
              </div>
              <div className="d-flex flex-column align-items-center">
                <span className="mb-0 eventNameTypography" style={{ marginTop: "2rem" }}>
                  {hasWhiteSpace(event.name) ? event.name : event.name.length > 15 ? event.name.substring(0, 15) + '...' : event.name}
                </span>
                <span
                  className="mt-3"
                  style={{
                    marginTop: "2rem",
                    wordSpacing: "5px",
                    fontWeight: 500,
                  }}
                >
                  {formatDate(event.start)} - {formatDate(event.end)}
                  <img src={line} alt="" className="px-2 mb-1" />
                  {event.venue}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="profile-container profile-container-new-video">
          {userContext.user ? (
            <div className="card mb-4">
              <div className="d-flex align-items-center">
                <div className="image profile-picture">
                  {userContext.user?.picture ? (
                    <img
                      height={50}
                      src={getEncodedImageUrl(
                        userContext.user?.picture,
                        110,
                        100,
                        "contain"
                      )}
                      alt="logo"
                      className="rounded profileImage"
                    />
                  ) : (
                    <img
                      src="/images/placeholder.svg"
                      className="rounded profileImage"
                      width="50"
                    />
                  )}

                  {/*
              <img src="/icons/profile-edit.svg" className="edit" width="20" alt="" />
*/}
                </div>

                <div className="ml-3 w-100 text-right welcome">
                  {/* eventtypography */}
                  <span className="mb-0 mt-0 welcometypography">Welcome</span>
                  {/* speaker name  */}
                  <h6 className="profileNameTypography">
                    {/* {allSpeakers[0].label} */}
                    {userContext.user.name}
                  </h6>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* check user authorize or not  */}
          {/* checking user is speaker or not if yes then show my presentation button */}
          {console.log("userContext.user", userContext.user)}

          {userContext.user?.is_speaker ? (
            <div className="menu-conatiner">
              <div className="presentation-menu">
                <span className="title">{presentationName}</span>
                <div className="d-flex">
                  <span className="date">
                    {`${PresentationDate} 11h30 - 12h30`}
                    {/* DATE 11h30 - 12h30 */}
                  </span>
                  <span className="room">{roomName}</span>
                </div>
              </div>

              <div>
                <Button
                  className={` change-text-second active`}
                  // nav-link active
                  onClick={function () {
                    history.push("/" + event_slug + "/my-presentations");
                  }}
                >
                  <img src="/icons/back-blue.png" alt="presentations" />
                  <div>
                    <span className="text back-to-presentation">
                      <FormattedMessage id="menu.back.to.my.presentations" />
                    </span>
                  </div>
                </Button>
              </div>
            </div>
          ) : (
            <></>
          )}

          <i className="bi bi-chevron-right"></i>
        </div>
        <div className="nav-conatiner " style={{ padding: '0px' }}>

          <div className="nav-container-box">
            <Button
              className="nav-link active nav-link-back-button"
              onClick={() => setFilter({ ...filter, activeQuizzesOnly: false })}
            >
              <img src="/icons/back-arrow.svg" className="rounded " />

            </Button>

            <Button
              className={` nav-link  ${box == "record" ? "active" : ""} `}

              onClick={function () {
                setFilter({ ...filter, activeQuizzesOnly: false });
                window.open(`${process.env.REACT_APP_VISIO}/visio/record/${slug}/${PresentationId}/${userContext.user?.id}/${localStorage.getItem("locale") ? localStorage.getItem("locale") : 'en'}/${localStorage.getItem(`token-${slug}`)}`, '_self')
              }}
            >
              <img src="/icons/record-video.svg" alt="schedule" />
              <span className="text">
                <FormattedMessage id="menu.record.video" />
              </span>
              {box == "record" ? <div className="rectangular-box"></div> : ""}
            </Button>

            <Button
              // className={`nav-link ${filter.activeQuizzesOnly ? "" : "-active"}`}
              className={`${visioEnabled ? "" : "fade-color disabled"} nav-link   ${box == "live" ? "active" : ""} `}

              // onClick={() => setFilter({ ...filter, activeQuizzesOnly: false })}
              onClick={function () {
                if (visioEnabled) {
                  setFilter({ ...filter, activeQuizzesOnly: false });
                  window.open(`${process.env.REACT_APP_VISIO}/visio/${PresentationId}/${userContext.user?.id}`, '_self')
                }
              }}
            >
              <img src="/icons/live-stream.svg" alt="schedule" />
              <span className="text">
                <FormattedMessage id="menu.live.stream" />
              </span>
              {/* <div className="rectangular-box"></div> */}
              {box == "live" ? <div className="rectangular-box"></div> : ""}
            </Button>




            <Button
              // className={`nav-link ${filter.activeQuizzesOnly ? "" : "-active"}`}
              className={`nav-link   ${box == "videos" ? "active" : ""} `}

              // className="nav-link active"
              // onClick={() => setFilter({ ...filter, activeQuizzesOnly: false })}
              onClick={function () {
                setFilter({ ...filter, activeQuizzesOnly: false });
                setBox("videos");
              }}
            >
              <img src="/icons/my-videos.svg" alt="schedule" />
              <span className="text">
                <FormattedMessage id="menu.my.videos" />
              </span>

              {box == "videos" ? <div className="rectangular-box"></div> : ""}
              {/* <div className="rectangular-box"></div> */}
            </Button>
          </div>
          {/* <div
            className="ad-container"
            dangerouslySetInnerHTML={{
              __html: event.ad,
            }}
          ></div> */}
          {/* <Footer /> */}
          <div
            className={`filters-container-bar  filter-mobile-top ${showFilters ? "show-filters" : ""}`}
          >
            <div className="filter-contents">
              {allSpeakers.length > 1 && (
                <FilterDropdown
                  selectPlaceholder={intl.formatMessage({ id: "select.speakers" })}
                  filterName={intl.formatMessage({ id: "sidebar.speakers" })}
                  options={allSpeakers}
                  value={filter.speakers}
                  setValue={(val: Array<string>) =>
                    setFilter({
                      ...filter,
                      speakers: val,
                    })
                  }
                />
              )}
              {allRooms.length > 1 && (
                <FilterDropdown
                  selectPlaceholder={intl.formatMessage({ id: "select.room" })}
                  filterName={intl.formatMessage({ id: "room" })}
                  options={allRooms}
                  value={filter.rooms}
                  setValue={(val: Array<string>) =>
                    setFilter({
                      ...filter,
                      rooms: val,
                    })
                  }
                />
              )}
              {allAssosiations.length > 1 && (
                <FilterDropdown
                  selectPlaceholder={intl.formatMessage({
                    id: "select.association",
                  })}
                  filterName="Association"
                  options={allAssosiations}
                  value={filter.associations}
                  setValue={(val: Array<string>) =>
                    setFilter({
                      ...filter,
                      associations: val,
                    })
                  }
                />
              )}
              {allDates.length > 1 && (
                <FilterDropdown
                  selectPlaceholder={intl.formatMessage({ id: "select.dates" })}
                  filterName={intl.formatMessage({ id: "dates" })}
                  options={allDates}
                  value={filter.dates}
                  setValue={(val: Array<string>) =>
                    setFilter({
                      ...filter,
                      dates: val,
                    })
                  }
                />
              )}

              {/* <Button><img src="/icons/rooms-ico.svg" alt="" /></Button> */}

              {/* {
            hasActiveQuizzes
            && <Button className={`nav-link ${filter.activeQuizzesOnly ? 'active' : ''}`} onClick={() => setFilter({ ...filter, activeQuizzesOnly: true })}><img src="/icons/quiz.svg" alt="Quiz" /><span className="text"><FormattedMessage id="menu.quiz" /></span></Button>
          } */}

              {/*<div className="formik-radio has-quizes">
            <Label className="label-color" htmlFor="has-active-quizzes">
              <input
                name="has-active-quizzes"
                id="has-active-quizzes"
                type="checkbox"
                checked={filter.activeQuizzesOnly}
                onChange={(e) =>
                  setFilter({ ...filter, activeQuizzesOnly: e.target.checked })
                }
                className="radio-button"
              />
              <span className="text">
                {intl.formatMessage({ id: "presentation.with.quiz" })}
              </span>
              <span className="radio-btn"></span>
            </Label>
          </div>*/}

            </div>
            {filters ? (

              <div className="filter_button">
                <Button
                  onClick={() => toggleFilters()}
                  className="filter-btn"
                  color="primary"
                >

                  <span className={`filter-span ${showFilters ? "" : "filter-span-inactive"}`}>
                    {intl.formatMessage({ id: "filters" })}
                    <img
                      src="/icons/filter-arrow.svg"
                      alt=""
                    />
                  </span>
                </Button>
              </div>

            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  };

export default SidebarNewVideo;
